export default __webpack_public_path__ + "static/media/share.15377cb5.svg";